import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Records from './views/Records.vue'
import IndividualRecords from './views/IndividualRecords.vue'
import Applying from './views/Applying.vue'
import UserManage from './views/UserManage.vue'
import Inquiry from './views/Inquiry.vue'
import firebase from 'firebase/app'
import 'firebase/database'
// import config from './config/adminUsersEmail'
import dayjs from 'dayjs'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/applying',
      name: 'applying',
      component: Applying
    },
    {
      path: '/userManage',
      name: 'userManage',
      component: UserManage
    },
    {
      path: '/inquiry',
      name: 'inquiry',
      component: Inquiry
    },
    {
      path: '/records',
      name: 'records',
      component: Records,
      meta: { title: '記録一覧 | 空蝉' }
    },
    {
      path: '/individualRecords',
      name: 'individualRecords',
      component: IndividualRecords,
      meta: { title: '個人記録 | 空蝉' },
      props: true
    },
    {
      path: '*',
      name: 'others',
      component: Login
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      const position = {}
      if (to.hash) {
        position.selector = to.hash
        return position
      } else {
        return { x: 0, y: 0 }
      }
    }
  }
})

// 未認証の場合はログイン画面へ
router.beforeResolve((to, from, next) => {
  if (to.path == '/') {
    next()
  } else {

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        // ログイン状態の場合
        if (to.meta && to.meta.title) {
          document.title = to.meta.title
        }
        if (to.path == '/applying') {
          next();
        } else {
          firebase.database().ref('users/' + firebase.auth().currentUser.uid).on("value", data => {
            if (data.val()) {
              var authorized = true;
              authorized = data.val()["authorized"]
              if (!authorized) {
                next("applying")
              } else {
                if (to.path == '/userManage') {
                  next();
                  // if(config.adminUsersEmail.includes(firebase.auth().currentUser.email)){
                  //   next();
                  // } else {
                  //   next("records");
                  // }
                } else {
                  next();
                }
              }
            } else {
              firebase.database().ref('users/' + firebase.auth().currentUser.uid).update({
                authorized: false,
                email: firebase.auth().currentUser.email,
                lastUpdateDate: dayjs().unix(),
              })
              next("applying");
            }
          })
        }


        // if(to.path=="/applying"){
        //   console.log("move to applying");
        //   next();
        // } else {
        //   console.log("move to other pages");
        //   var authorized = false;
        //   firebase.database().ref('users/'+firebase.auth().currentUser.uid).on("value",data=>{
        //     console.log("data :"+data)
        //     if(data){
        //       console.log("Data exists")
        //       authorized = data.val()["authorized"]
        //       console.log("authorized: "+authorized)
        //     } else {
        //       console.log("No data");
        //     }
        //   })
        //   if(!authorized){
        //     console.log("unauthorized")
        //     // firebase.database().ref('users/'+firebase.auth().currentUser.uid).update({
        //     //   authorized : false,
        //     // })
        //     next({path: '/applying'});
        //   } else {
        //     if (to.meta && to.meta.title) {
        //       document.title = to.meta.title
        //     }
        //     next()
        //   }
        // }
      } else {
        // 未ログイン状態の場合
        switch (to.path) {
          case '/read':
            next();
            break;
          default:
            console.log('未認証')
            next({ path: '/' })
        }
      }
    })
  }
})

export default router
